// Producción SG (Software Ganadero) — presentación del bloque «último-X»
// (public-client-channel.md §donors, opt-in ?include=sg_production, Q-123).
// Pure data: el backend entrega UN evento por feature (el más reciente); el
// front solo mapea key→label/icono y formatea — nunca deriva ni prorratea.
//
// fmt: 'num' → fmtNum · 'text' → tal cual. Campos ausentes/null se omiten.

export const SG_FEATURES = [
    {
        key: 'milk',
        label: 'Leche',
        icon: 'milk',
        fields: [
            { key: 'liters', label: 'Litros', fmt: 'num' },
            { key: 'am',     label: 'AM',     fmt: 'num' },
            { key: 'pm',     label: 'PM',     fmt: 'num' },
        ],
    },
    {
        key: 'weight',
        label: 'Pesaje',
        icon: 'scale',
        fields: [
            { key: 'peso',   label: 'Peso (kg)', fmt: 'num' },
            { key: 'alzada', label: 'Alzada',    fmt: 'num' },
        ],
    },
    {
        key: 'service',
        label: 'Servicio',
        icon: 'syringe',
        fields: [
            { key: 'bull_name', label: 'Toro', fmt: 'text' },
            { key: 'tipo',      label: 'Tipo', fmt: 'text' },
        ],
    },
];
